import { FunctionComponent, useMemo } from 'react'

import {
  ProviderInfoSection,
  ProviderDrawerSection,
  ProviderDrawer,
  ShareLinkButton
} from '@/modules/accredited-establishments/components'

import { WParagraph } from '@alice-health/wonderland-react'
import {
  buildShareUrl,
  getProviderDetailImage,
  toList
} from '@/modules/accredited-establishments/functions'
import { useGetProviderDetail } from '@/modules/accredited-establishments/hooks/useGetProviderDetail'
import { ESTABLISHMENT_DRAWER_ID } from './EstablishmentDetailDrawer.constants'

interface EstablishmentDetailDrawerProps {
  referencedId?: string
}

const EstablishmentDetailDrawer: FunctionComponent<
  EstablishmentDetailDrawerProps
> = ({ referencedId }) => {
  const { data, isLoading, isError } = useGetProviderDetail({
    referencedId
  })

  const details = useMemo(() => {
    if (!data) return undefined

    return {
      title: data.title,
      image: getProviderDetailImage(data.icon, data.category),
      /* Unica tag do node 26:41637. */
      tags: data.cnpj ? [`CNPJ ${data.cnpj}`] : undefined
    }
  }, [data])

  return (
    <ProviderDrawer
      id={ESTABLISHMENT_DRAWER_ID}
      kind='establishment'
      loading={isLoading}
      error={isError}
      data={details}
      actions={
        /*
         * `getUrl` so roda no clique: resolver a URL cedo (num useMemo
         * travado so em `referencedId`) corre o risco de capturar o endereco
         * de antes do selamento assincrono (Web Crypto) terminar.
         */
        referencedId ? (
          <ShareLinkButton
            getUrl={() => buildShareUrl(referencedId)}
            title={details?.title}
          />
        ) : null
      }
    >
      {data?.subCategories ? (
        <ProviderDrawerSection title='Subespecialidades'>
          <WParagraph mode='tertiary'>{data.subCategories}</WParagraph>
        </ProviderDrawerSection>
      ) : null}

      {data?.includedPlans ? (
        <ProviderDrawerSection title='Planos'>
          <WParagraph mode='tertiary'>{toList(data.includedPlans)}</WParagraph>
        </ProviderDrawerSection>
      ) : null}

      <ProviderDrawerSection title='Atendimento'>
        <ProviderInfoSection
          address={
            data?.address
              ? [{ address: data.address, lat: data.lat, lon: data.lon }]
              : undefined
          }
          phones={data?.phones}
          isCassi={data?.contractOrigin === 'CASSI'}
        />
      </ProviderDrawerSection>
    </ProviderDrawer>
  )
}

export type { EstablishmentDetailDrawerProps }

export { EstablishmentDetailDrawer }
